
import Vue from "vue"

export default Vue.extend({
  props: {
    label: { type: String, default: "vkAppShortBtn" },
    large: { type: Boolean, default: false },
  },

  data: () => ({
    isDialogOpen: false,
  }),
})
